// lib
import Window from 'ln/node/Window';
import Node from 'ln/node/Node';
import View from 'ln/view/View';
import { scanner } from 'ln/view/Scanner';


class HeaderScrollMonitor extends View {

	top:number;

	constructor( top:number = 20 ) {

		super( {} );

		this.top = top;
	}
	
	init() {
		Window.scroll.add( this.checkScroll, this );
	}

	private checkScroll() {
		this.node.toggleClass( 'small', Window.scrollInfo().top > this.top );
	}
}

export default HeaderScrollMonitor;

scanner.ioc.add( 'scroll-monitor', function( node ) {
	return new HeaderScrollMonitor( node.data.top ).render( node );
});